import { IconWrapper } from '../runtime';
export default IconWrapper('share-to', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M1 11.6997V13.4997C1 14.3282 1.67157 14.9997 2.5 14.9997H13.5C14.3284 14.9997 15 14.3282 15 13.4997V11.6997M1 8.99974C5.30712 4.5495 9.11642 4.20044 14.8742 4.46935M14.8742 4.46935C14.8675 4.40299 14.8387 4.33844 14.7879 4.28759L11.5 0.999725M14.8742 4.46935C14.883 4.5559 14.8542 4.64554 14.7879 4.71186L11.5 7.99973",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});